// extracted by mini-css-extract-plugin
module.exports = {"root":"AccordionBlok_root__cMijw","items":"AccordionBlok_items__3b_2x"};